import { Fragment } from 'react'
import s from './TenFourText.module.css'

/** Inline brand lettering, sized and colored by the surrounding copy. */
export function TenFourName() {
  return <span className={s.name}>tenfour</span>
}

/** Brand only the name in app copy; labels remain plain strings for accessibility. */
export function TenFourText({ children }: { children: string }) {
  return <>{children.split(/\b(tenfour)\b/).map((part, index) => (
    <Fragment key={index}>{part === 'tenfour' ? <TenFourName /> : part}</Fragment>
  ))}</>
}
